import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FileAttachment } from "ng/src/app/notes/shared/file-attachments/file-attachment.model";

@Injectable({
	providedIn: 'root'
})
export class FileService {
	static readonly MAX_FILE_SIZE = 26_000_000;
	
	constructor(
		private http: HttpClient
	) {}
	
	uploadFiles(files: File[], logId: number) {
		return files.map(file => {
			const formData = new FormData();
			
			formData.append('file', file);
			formData.append('logId', logId.toString());
			
			return this.http.post<FileAttachment>('/api/files', formData, {
				headers: {
					'accept': 'application/json'
				}
			});
		});
	}
	
}